module.exports = __webpack_public_path__ + "static/img/16.6b66994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/16.jpg
// module id = gmz7
// module chunks = 1